<template>
  <div class="loyalty-benefits-icons-container container">
    <div class="loyalty-benefits-icons">
      <div class="icon-container">
        <i class="icon icon-star" />
        <p>Exclusive rewards</p>
      </div>
      <div class="icon-container">
        <i class="icon icon-sell-tag" />
        <p>Priority sale access</p>
      </div>
      <div class="icon-container">
        <i class="icon icon-add-task" />
        <p>Vote on styles</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoyaltyBenefitIcons",
};
</script>

<style lang="scss" scoped>
.loyalty-benefits-icons {
  display: flex;
  justify-content: center;
  font-size: 20px;
  margin-bottom: 50px;

  @include respond-above(md) {
    margin: 0 auto 140px;
  }
}

.icon-container {
  text-align: center;
  flex: 0 1 150px;

  p {
    font-family: $body-font-family;
    font-size: 13px;
    font-weight: 400;
    margin: 10px 10px;
  }
}
</style>
